var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chartist',{staticClass:"observation-bar",attrs:{"ratio":"","type":"Bar","data":_vm.data,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }